<template>
    <v-content style="background-color:#EEEEEE">
      <Notification ref="notif" v-bind="notif" v-on:update="notif.show = $event"></Notification>
      <v-container grid fill-height>
        <v-layout justify-center>
          <v-flex x12>
            <div class="text-xs-center">
              <img :src="Logo" alt="logo" style="width:24vw;margin-bottom:5vh;"/>
              <h2 class="display-4 font-weight-bold cyan--text" style="margin-bottom:5vh;" v-show="showCode">{{ErrorCode}}</h2>
              <p text--center class="display-1 font-weight-thin red--text" style="margin-bottom:5vh;" align-center>{{ErrorMessage}}</p>
              <p text--center class="title font-weight-thin red--text" style="margin-bottom:5vh;" align-center>Please contact to Administrator for help</p>
              <div>
                <v-btn round color="green" v-show="showRoute" dark @click="route">Go to {{getRouteName}}</v-btn>
                <v-btn round dark @click="Logout">Logout</v-btn>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
</template>

<script>
import LogoSvg from '@/assets/agentHelperLogo.svg';
import Notification from '@/components/Notification.vue';

export default {
  name: 'errorView',
  components: {
    Notification,
  },
  props: {
    message: {
      type: String,
      required: true,
    },
    errorcode: String,
  },
  data() {
    return {
      Logo: LogoSvg,
      ErrorMessage: this.message,
      ErrorCode: this.errorcode,
      RouteInfo: this.$store.getters.getDefaultRoute,
      notif: {
        color: 'success',
        message: '',
        show: false,
      },
    };
  },
  computed: {
    getRouteName() {
      return this.RouteInfo && this.RouteInfo.name ? this.RouteInfo.name : '';
    },
    showRoute() {
      return this.RouteInfo && this.RouteInfo.route && this.RouteInfo.route.length > 0;
    },
    showCode() {
      return this.ErrorCode && this.ErrorCode.length > 0;
    },
  },
  methods: {
    showNotif(obj) {
      const that = this;
      that.notif.show = true;
      that.notif.message = obj.message;
      that.notif.color = obj.color;
    },
    route() {
      this.$router.replace(`/${this.RouteInfo.route}`);
    },
    Logout() {
      this.$store.dispatch('logout')
        .then((result) => {
          if (result) this.$router.replace('/login');
          else this.showNotif({ color: 'error', message: 'Logout failed' });
        })
        .catch((error) => {
          this.showNotif({ color: 'error', message: 'Logout failed' });
        });
    },
  },
};
</script>
